import { RootState } from "@/redux/store";

export const addOnsSelector = (state: RootState) => state.addOn.addOns;
export const featuresSelector = (state: RootState) => state.addOn.features;
export const addOnItemSelector = (id: string) => (state: RootState) => state.addOn.addOns.find((a) => a.identifier === id);
export const featureItemSelector = (id: string) => (state: RootState) => state.addOn.features.find((a) => a.identifier === id);